export const permissons = {
  Admin: {
    READ: "View Admins",
    WRITE: "Manage Admins",
  },
  Roles: {
    READ: "View Roles",
    WRITE: "Manage Roles",
  },
  Users: {
    READ: "View Users",
    WRITE: "Manage Users",
  },
  Subscription: {
    READ: "View Subscriptions",
    WRITE: "Manage Subscriptions",
  },
  Course: {
    READ: "View Courses",
    WRITE: "Manage Courses",
  },
  Template: {
    READ: "View Templates",
    WRITE: "Manage Templates",
  },
  Dashboard: {
    READ: "View Dashboard",
    WRITE: "Dashboard Analytics",
  },
};

export const labels = {
  Admin: "Admin Management",
  Roles: "Role Management",
  Users: "User Management",
  Subscription: "Subscription Management",
  Course: "Course Management",
  Template: "Template Management",
  Dashboard: "Dashboard",
};
